export const constants = {
  redirectionAllowedDomains: ['.movinmotion.com', '.movinmotion.net', 'odalie2.thalie-sante.org'],
};

export default constants;
